// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-link {
  padding: 1rem 1.5rem;
  position: relative;
  color: rgba(255, 255, 255, 0.9) !important;
  transition: all 0.2s ease;
}
.nav-link i {
  margin-right: 0.5rem;
  font-size: 1.1rem;
}
.nav-link.active:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 1.5rem;
  right: 1.5rem;
  height: 2px;
  background-color: white;
}
.nav-link:hover {
  color: white !important;
}

.navbar-nav {
  position: relative;
  gap: 0.5rem;
}
.navbar-nav .dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  float: none;
  min-width: 12rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  color: #525f7f;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-radius: 0.375rem;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}

.nav-divider {
  height: 24px;
  width: 1px;
  background-color: rgba(255, 255, 255, 0.3);
  margin: 8px 15px;
}

.navbar {
  position: relative;
  z-index: 1050;
}
@media (max-width: 991.98px) {
  .navbar {
    padding: 0.5rem;
  }
}
.navbar .navbar-brand {
  padding: 0;
}
.navbar .navbar-brand img.navbar-brand-img {
  height: auto;
}
.navbar .navbar-toggler {
  padding: 0.5rem;
  border: none;
}
.navbar .navbar-toggler:focus {
  box-shadow: none;
}
@media (max-width: 991.98px) {
  .navbar .navbar-collapse {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100vh - 72px);
    margin-top: 72px;
    background: #1a936f;
    padding: 1rem;
    z-index: 1050;
    overflow-y: auto;
  }
  .navbar .navbar-collapse:not(.show) {
    display: none !important;
  }
  .navbar .navbar-collapse .navbar-nav {
    padding-bottom: 2rem;
  }
  .navbar .navbar-collapse .navbar-nav .nav-item .nav-link {
    padding: 1rem 0;
    font-size: 1.1rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  .navbar .navbar-collapse .navbar-nav .nav-item .nav-link i {
    width: 24px;
    margin-right: 0.5rem;
  }
  .navbar .navbar-collapse .navbar-nav .nav-item .nav-divider {
    display: none;
  }
}

@media (max-width: 575.98px) {
  .navbar .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-brand {
    margin-right: 0.5rem;
  }
  .navbar-brand img.navbar-brand-img {
    max-width: 40px;
  }
  .navbar-toggler {
    margin-left: auto;
  }
  .navbar > .container-fluid > .navbar-nav {
    margin-left: 0.5rem !important;
  }
}
.mobile-menu-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1020;
}

@media (max-width: 991.98px) {
  .dropdown-menu {
    position: fixed !important;
    top: auto !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    width: 100%;
    margin: 0;
    border-radius: 1rem 1rem 0 0;
    z-index: 1051;
  }
}

:host-context(body).mobile-menu-open {
  overflow: hidden;
  position: fixed;
  width: 100%;
}

.nav-item.dropdown {
  position: static;
}
@media (min-width: 992px) {
  .nav-item.dropdown {
    position: relative;
  }
}
.nav-item.dropdown .dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  z-index: 1050;
  float: none;
  min-width: 12rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  color: #525f7f;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-radius: 0.375rem;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}
@media (max-width: 991.98px) {
  .nav-item.dropdown .dropdown-menu {
    width: calc(100% - 2rem);
    margin: 1rem;
  }
}
.nav-item.dropdown .dropdown-menu.show {
  display: block;
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
  animation: dropdownAnimation 0.3s ease forwards;
}

@keyframes dropdownAnimation {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,kBAAA;EACA,0CAAA;EACA,yBAAA;AACF;AACE;EACE,oBAAA;EACA,iBAAA;AACJ;AAGI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;AADN;AAKE;EACE,uBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,WAAA;AAJF;AAME;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,SAAA;EACA,uBAAA;EACA,iHAAA;AAJJ;;AASA;EACE,YAAA;EACA,UAAA;EACA,0CAAA;EACA,gBAAA;AANF;;AASA;EACE,kBAAA;EACA,aAAA;AANF;AAQE;EAJF;IAKI,eAAA;EALF;AACF;AAOE;EACE,UAAA;AALJ;AAOI;EACE,YAAA;AALN;AASE;EACE,eAAA;EACA,YAAA;AAPJ;AASI;EACE,gBAAA;AAPN;AAYI;EADF;IAEI,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,0BAAA;IACA,gBAAA;IACA,mBAAA;IACA,aAAA;IACA,aAAA;IACA,gBAAA;EATJ;EAWI;IACE,wBAAA;EATN;EAYI;IACE,oBAAA;EAVN;EAaQ;IACE,eAAA;IACA,iBAAA;IACA,iDAAA;EAXV;EAaU;IACE,WAAA;IACA,oBAAA;EAXZ;EAeQ;IACE,aAAA;EAbV;AACF;;AAoBA;EACE;IACE,iBAAA;EAjBF;EAoBA;IACE,oBAAA;EAlBF;EAqBA;IACE,eAAA;EAnBF;EAsBA;IACE,iBAAA;EApBF;EAuBA;IACE,8BAAA;EArBF;AACF;AAwBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;AAtBF;;AA2BE;EADF;IAEI,0BAAA;IACA,oBAAA;IACA,oBAAA;IACA,kBAAA;IACA,mBAAA;IACA,WAAA;IACA,SAAA;IACA,4BAAA;IACA,aAAA;EAvBF;AACF;;AA4BE;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AAzBJ;;AA6BA;EACE,gBAAA;AA1BF;AA2BE;EAFF;IAGI,kBAAA;EAxBF;AACF;AA0BE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,SAAA;EACA,uBAAA;EACA,iHAAA;AAxBJ;AA2BI;EArBF;IAsBI,wBAAA;IACA,YAAA;EAxBJ;AACF;AA0BI;EACE,cAAA;EACA,UAAA;EACA,oBAAA;EACA,wBAAA;EACA,+CAAA;AAxBN;;AA6BA;EACE;IACE,UAAA;IACA,2BAAA;EA1BF;EA4BA;IACE,UAAA;IACA,wBAAA;EA1BF;AACF","sourcesContent":[".nav-link {\n  padding: 1rem 1.5rem;\n  position: relative;\n  color: rgba(255, 255, 255, 0.9) !important;\n  transition: all 0.2s ease;\n\n  i {\n    margin-right: 0.5rem;\n    font-size: 1.1rem;\n  }\n\n  &.active {\n    &:after {\n      content: '';\n      position: absolute;\n      bottom: 0;\n      left: 1.5rem;\n      right: 1.5rem;\n      height: 2px;\n      background-color: white;\n    }\n  }\n\n  &:hover {\n    color: white !important;\n  }\n}\n\n.navbar-nav {\n  position: relative;\n  gap: 0.5rem;\n\n  .dropdown-menu {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    left: auto;\n    float: none;\n    min-width: 12rem;\n    padding: 0.5rem 0;\n    margin: 0.125rem 0 0;\n    font-size: 0.875rem;\n    color: #525f7f;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 0;\n    border-radius: 0.375rem;\n    box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),\n      0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);\n  }\n}\n\n.nav-divider {\n  height: 24px;\n  width: 1px;\n  background-color: rgba(255, 255, 255, 0.3);\n  margin: 8px 15px;\n}\n\n.navbar {\n  position: relative;\n  z-index: 1050;\n\n  @media (max-width: 991.98px) {\n    padding: 0.5rem;\n  }\n\n  .navbar-brand {\n    padding: 0;\n\n    img.navbar-brand-img {\n      height: auto;\n    }\n  }\n\n  .navbar-toggler {\n    padding: 0.5rem;\n    border: none;\n\n    &:focus {\n      box-shadow: none;\n    }\n  }\n\n  .navbar-collapse {\n    @media (max-width: 991.98px) {\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: calc(100vh - 72px);\n      margin-top: 72px;\n      background: #1a936f;\n      padding: 1rem;\n      z-index: 1050;\n      overflow-y: auto;\n\n      &:not(.show) {\n        display: none !important;\n      }\n\n      .navbar-nav {\n        padding-bottom: 2rem;\n\n        .nav-item {\n          .nav-link {\n            padding: 1rem 0;\n            font-size: 1.1rem;\n            border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\n            i {\n              width: 24px;\n              margin-right: 0.5rem;\n            }\n          }\n\n          .nav-divider {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 575.98px) {\n  .navbar .container-fluid {\n    flex-wrap: nowrap;\n  }\n\n  .navbar-brand {\n    margin-right: 0.5rem;\n  }\n\n  .navbar-brand img.navbar-brand-img {\n    max-width: 40px;\n  }\n\n  .navbar-toggler {\n    margin-left: auto;\n  }\n\n  .navbar > .container-fluid > .navbar-nav {\n    margin-left: 0.5rem !important;\n  }\n}\n\n.mobile-menu-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.3);\n  z-index: 1020;\n}\n\n// User menu adjustments\n.dropdown-menu {\n  @media (max-width: 991.98px) {\n    position: fixed !important;\n    top: auto !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    width: 100%;\n    margin: 0;\n    border-radius: 1rem 1rem 0 0;\n    z-index: 1051;\n  }\n}\n\n// Prevent body scroll when mobile menu is open\n:host-context(body) {\n  &.mobile-menu-open {\n    overflow: hidden;\n    position: fixed;\n    width: 100%;\n  }\n}\n\n.nav-item.dropdown {\n  position: static;\n  @media (min-width: 992px) {\n    position: relative;\n  }\n\n  .dropdown-menu {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    left: auto;\n    z-index: 1050;\n    float: none;\n    min-width: 12rem;\n    padding: 0.5rem 0;\n    margin: 0.125rem 0 0;\n    font-size: 0.875rem;\n    color: #525f7f;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 0;\n    border-radius: 0.375rem;\n    box-shadow: 0 50px 100px rgb(50 50 93 / 10%),\n      0 15px 35px rgb(50 50 93 / 15%), 0 5px 15px rgb(0 0 0 / 10%);\n\n    @media (max-width: 991.98px) {\n      width: calc(100% - 2rem);\n      margin: 1rem;\n    }\n\n    &.show {\n      display: block;\n      opacity: 1;\n      pointer-events: auto;\n      transform: translateY(0);\n      animation: dropdownAnimation 0.3s ease forwards;\n    }\n  }\n}\n\n@keyframes dropdownAnimation {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
